import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/* Une app installée reste ouverte des jours : elle ne voit pas qu'une nouvelle version a
   été mise en ligne. À chaque retour sur l'app (et toutes les 10 minutes), on compare le
   programme chargé à celui du site ; s'il a changé, un bandeau propose de mettre à jour. */
const programme = (html) => (String(html).match(/\/static\/js\/main\.[0-9a-f]+\.js/) || [""])[0];

export const MiseAJour = () => {
  const [nouvelle, setNouvelle] = useState(false);
  useEffect(() => {
    const actuel = programme(document.documentElement.innerHTML);
    if (!actuel) return undefined;
    const verifier = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const r = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
        const enLigne = programme(await r.text());
        if (enLigne && enLigne !== actuel) setNouvelle(true);
      } catch { /* hors ligne */ }
    };
    document.addEventListener("visibilitychange", verifier);
    const minuterie = setInterval(verifier, 10 * 60 * 1000);
    verifier();
    return () => { document.removeEventListener("visibilitychange", verifier); clearInterval(minuterie); };
  }, []);
  if (!nouvelle) return null;
  return (
    <button onClick={() => window.location.reload()} data-testid="mise-a-jour"
      className="fixed z-[80] left-1/2 -translate-x-1/2 inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-white shadow-lg"
      style={{ top: "calc(0.75rem + env(safe-area-inset-top, 0px))", background: "#0F1B2D" }}>
      <RefreshCw size={15} /> Nouvelle version — toucher pour mettre à jour
    </button>
  );
};
